module.exports = require("./tg");